import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

interface MultiSelectProps {
  options: Array<{ value: string; label: string }>;
  value: Array<{ value: string; label: string }>;
  onChange: (value: any) => void;
  isMulti?: boolean;
  placeholder?: string;
}

export default function MultiSelect({
  options,
  value,
  onChange,
  isMulti = true,
  placeholder = 'Select...',
}: MultiSelectProps) {
  return (
    <Select
      closeMenuOnSelect={!isMulti}
      components={animatedComponents}
      options={options}
      isMulti={isMulti}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
    />
  );
}
